// extracted by mini-css-extract-plugin
module.exports = {"slots":"TimeSlots_slots__1dHC5","slots__duration":"TimeSlots_slots__duration__LWJPg","slots__date":"TimeSlots_slots__date__Q7PoV","slots__name":"TimeSlots_slots__name__14BQH"};